import type { MonitoringObservation } from '@/services/platform/platform.http'

export type MonitoringViewState = 'loading' | 'error' | 'empty' | 'ready' | 'stale'

export function monitoringViewState(loading: boolean, error: string, items: MonitoringObservation[]): MonitoringViewState {
  if (loading) return 'loading'
  if (error) return 'error'
  if (items.length === 0) return 'empty'
  if (items.some((item) => item.stale || item.last_snapshot?.stale)) return 'stale'
  return 'ready'
}

export function statusTone(status: MonitoringObservation['status']): string {
  if (status === 'healthy') return 'text-green-700 bg-green-50'
  if (status === 'degraded') return 'text-amber-700 bg-amber-50'
  return 'text-red-700 bg-red-50'
}
